import callAPiBase from './base';

const scheduleApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/calendarList',
      method: 'GET',
      useToken: true,
      title: 'Schedule - Get List',
      params,
    }),
  createByList: ({
    data,
  }: {
    data: Array<{
      date: number;
      month: number;
      year: number;
      type: number;
      name: string;
    }>;
  }) =>
    callAPiBase({
      endpoint: '/calendarListCreate',
      method: 'POST',
      useToken: true,
      title: 'Schedule - Create',
      data,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/calendarCreate',
      method: 'POST',
      useToken: true,
      title: 'Schedule - Create',
      data,
    }),
  updateByList: ({
    data,
  }: {
    data: Array<{
      calendarId: string;
      date: number;
      month: number;
      year: number;
      type: number;
      name: string;
    }>;
  }) =>
    callAPiBase({
      endpoint: '/calendarListUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Schedule - Update',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/calendarUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Schedule - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/calendarDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Schedule - Delete',
      params,
    }),
};

export { scheduleApi };
export default scheduleApi;
